import { connect, ConnectedProps } from 'react-redux';
import { progressSelectorFactory } from '../../common';
import { RootState } from '../../reducers';
import { selectIsDataFromTriumph } from '../../store/selectors';
import { Holdings } from './components/holdings';
import {
  filteredResults,
  leftTable,
  rightTable,
  selectAfsls,
  selectClientAttachments,
  selectClientId,
  selectConsolidatedSecurityHoldings,
  selectParameters,
  selectSecurities,
  totalValue,
} from './store/selectors';
import { holdingsSlice } from './store/slice';
import {
  deleteClientAttachment,
  downloadClientAttachment,
  fetchAfsls,
  fetchClientAttachments,
  FetchConsolidatedHoldings,
  FetchConsolidatedHoldingsExtended,
  FetchConsolidatedSecurityHoldings,
  fetchSecurities,
  HoldingsActionTypes,
} from './store/thunks';

const exportActionTypes = [HoldingsActionTypes.FetchAfsls, HoldingsActionTypes.FetchSecurities];

const mapStateToProps = (state: RootState) => ({
  parameters: selectParameters(state),
  selectConsolidatedSecurityHoldings: selectConsolidatedSecurityHoldings(state),
  leftTable: leftTable(state),
  rightTable: rightTable(state),
  filteredResults: filteredResults(state),
  totalValue: totalValue(state),
  loadingProgress: progressSelectorFactory([HoldingsActionTypes.FetchConsolidatedSecurityHoldings])(state),
  exportLoadingProgress: progressSelectorFactory(exportActionTypes)(state),
  exportingProcess: progressSelectorFactory([HoldingsActionTypes.FetchConsolidatedHoldings])(state),
  clientAttachmentsLoadingProgress: progressSelectorFactory([HoldingsActionTypes.FetchClientAttachments])(state),
  isDataFromTriumph: selectIsDataFromTriumph(state),
  afslDetails: selectAfsls(state),
  securityDetails: selectSecurities(state),
  clientAttachments: selectClientAttachments(state),
  clientId: selectClientId(state),
});

const mapDispatchToProps = {
  ...holdingsSlice.actions,
  FetchConsolidatedSecurityHoldings,
  FetchConsolidatedHoldings,
  FetchConsolidatedHoldingsExtended,
  fetchAfsls,
  fetchSecurities,
  fetchClientAttachments,
  deleteAttachment: deleteClientAttachment,
  downloadAttachment: downloadClientAttachment,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export type Props = ConnectedProps<typeof connector>;
export const HoldingsContainer = connect(mapStateToProps, mapDispatchToProps)(Holdings);
